const ArrowLeftIcon = (props: { [key: string]: unknown }) => (
  <svg
    width={7}
    height={10}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.4}
      // eslint-disable-next-line
      d="M5.336 1 3.573 2.398C2.167 3.513 1.464 4.07 1.356 4.749a1.59 1.59 0 0 0 0 .502c.108.679.811 1.236 2.217 2.351L5.336 9"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

export default ArrowLeftIcon;
